import { CLIENT_ID_HEADER, ClientId } from '../constants/clientId';

const urlOf = (input: RequestInfo | URL): string => {
  if (typeof input === 'string') return input;
  if (input instanceof URL) return input.href;
  return input.url;
};

/**
 * Wrap `window.fetch` so every request to `apiHost` carries the X-Payaca-Client
 * header. Existing values on the call site are preserved. Call once at app boot,
 * before any code makes a fetch.
 */
export const installClientIdFetchInterceptor = ({
  clientId,
  apiHost,
}: {
  clientId: ClientId;
  apiHost: string;
}): void => {
  if (typeof globalThis.fetch !== 'function') return;
  const originalFetch = globalThis.fetch.bind(globalThis);

  globalThis.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    if (!urlOf(input).startsWith(apiHost)) {
      return originalFetch(input, init);
    }

    const headers = new Headers(
      init?.headers ?? (input instanceof Request ? input.headers : undefined)
    );
    if (!headers.has(CLIENT_ID_HEADER)) {
      headers.set(CLIENT_ID_HEADER, clientId);
    }

    return originalFetch(input, { ...init, headers });
  };
};
